import { render, staticRenderFns } from "./QAEdit.vue?vue&type=template&id=01c95112"
import script from "./QAEdit.vue?vue&type=script&lang=js"
export * from "./QAEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports